import * as ngCore from '@angular/core'

import type * as models from '../../../models'
import { Store } from '../../../store'

/** Renders the tool cells reserved by the table row layout. */
@ngCore.Component({
  selector: 'atn-ds-table-row-tools',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** Tools configured for the current row. */
  public readonly toolsSg = ngCore.input.required<readonly models.Tool[]>({
    alias: 'tools',
  })

  /** Shared table state receiving tool intent. */
  private readonly _store = ngCore.inject(Store)

  /** Prevents row navigation and forwards the tool to the table store. */
  public toolClickHandler(event: Event, tool: models.Tool): void {
    event.stopPropagation()
    this._store.runTool(tool, event)
  }
}
